<template>
  <nav class="breadcrumbs">
    <div class="breadcrumbs__folded is-hidden" ref="breadcrumbsFolded">
      <dropdown :visible="groupedvisible" :animation="animation" :position="wrapperposition" tabindex="0" @clickout="groupedvisible=false">
          <div class="link"  @click="groupedvisible=true">
            … <font-awesome-icon :icon="angleDown" />
          </div>
          <div slot="dropdown" ref="breadcrumbsWrapper" class="dialog">

          </div>
        </dropdown>
    </div>
    <div class="breadcrumbs__initial" ref="breadcrumbsInitial">
      <div
        v-for="element in path"
        :key="element.id"
        class="breadcrumbs__item">
        <strong
          v-if="element.disabled===true">
          {{ element.name }}
        </strong>
        <router-link
          v-else
          :to="element.link">
          <strong>{{ element.name }}</strong>
        </router-link>

        <span v-if="!isLast(element)" class="breadcrumbs__separator"><icon-arrow-right />
        </span>
      </div>

      <!-- Example
      <div class="breadcrumbs__item">
        <router-link to="/management">Área personal: <strong>Variables agregadas</strong></router-link>
        Personal area
        <span class="breadcrumbs__separator"><icon-arrow-right />
        </span>
      </div>
      <div class="breadcrumbs__item">
        Cocotero
        <dropdown :visible="visible" :animation="animation" :position="position" @clickout="visible=false">
          <div class="link breadcrumbs__dropdown" tabindex="0" @click="visible=true">
            <strong>Nº de quejas fundadas</strong> <font-awesome-icon class="breadcrumbs__dropdown-icon" :icon="angleDown" />
          </div>
          <div slot="dropdown" class="dialog">
            <div class="dialog__item">
              <router-link to="/chart1">Gráfica 1</router-link>
            </div>
            <div class="dialog__item">
              <router-link to="/chart2">Gráfica 2</router-link>
            </div>
          </div>
        </dropdown>
      </div>
      -->

    </div>
  </nav>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import dropdown from 'vue-my-dropdown';
import IconArrowRight from '@/components/shared/icons/IconArrowRight';

export default {
  components: {
    FontAwesomeIcon,
    dropdown,
    IconArrowRight
  },
  props: {
    path: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    angleDown () {
      return faAngleDown;
    }
  },
  data () {
    return {
      visible: false,
      groupedvisible: false,
      position: ['right', 'bottom', 'right', 'top'],
      wrapperposition: ['center', 'bottom', 'center', 'top'],
      animation: 'ani-fade',
      visibleNested: false,
      positionNested: ['left', 'top', 'right', 'top']
    };
  },
  methods: {
    isLast (e) {
      return this.path[this.path.length - 1] === e;
    },
    checkSize () {
      let wrapperW = document.querySelector('.topbar').clientWidth;
      let innerW = this.$refs.breadcrumbsInitial.offsetWidth;
      const settingsElement = document.querySelector('.settings');
      let settingsW = settingsElement ? settingsElement.clientWidth : 0;
      let navToggleW = document.querySelector('.nav-toggle').clientWidth;
      let elementMargins = 100;
      let totalWrapperW = wrapperW - navToggleW - settingsW - elementMargins;

      if (totalWrapperW < innerW) {
        return true;
      } else {
        return false;
      }
    },
    hideItems () {
      if (
        this.$refs.breadcrumbsInitial.querySelectorAll('.breadcrumbs__item')
          .length === 0
      ) {
        return;
      }

      var targetItem = this.$refs.breadcrumbsInitial.querySelector(
        '.breadcrumbs__item'
      );
      targetItem.classList.add('dialog__item');
      this.$refs.breadcrumbsWrapper.appendChild(targetItem);
      let overflowed = this.checkSize();
      if (overflowed) {
        this.hideItems();
      }
      this.checkFolded();
    },
    checkBreadcrumb () {
      let wrapperOverlow = this.checkSize();
      if (wrapperOverlow) {
        this.hideItems();
      } else {
        this.showItems();
      }
    },
    checkFolded () {
      var wrapper = this.$refs.breadcrumbsFolded;
      if (wrapper.querySelectorAll('.breadcrumbs__item').length > 0) {
        wrapper.classList.remove('is-hidden');
      } else {
        wrapper.classList.add('is-hidden');
      }
    },
    showItems () {
      if (
        this.$refs.breadcrumbsFolded.querySelectorAll('.breadcrumbs__item')
          .length === 0
      ) {
        return;
      }
      var targetItem = this.$refs.breadcrumbsWrapper.querySelector(
        '.breadcrumbs__item:last-child'
      );
      targetItem.classList.remove('dialog__item');

      var container = this.$refs.breadcrumbsInitial;
      container.insertBefore(targetItem, container.firstChild);
      let overflowed = this.checkSize();
      if (overflowed) {
        this.hideItems();
      } else {
        this.showItems();
      }
      this.checkFolded();
    }
  },
  mounted () {
    this.checkBreadcrumb();
    window.addEventListener('resize', this.checkBreadcrumb);
  },
  destroyed () {
    window.removeEventListener('resize', this.checkBreadcrumb);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";
.breadcrumbs {
  margin-left: $sp-margin;
  display: flex;
  align-items: baseline;
  border-left: 1px solid $white-trans6;
  padding-left: $sp-margin-small;
  font-size: $fs-s;
  @media (max-width: $screen-m-max) {
    display: none;
  }
  &__dropdown {
    display: flex;
    align-items: center;
    &:hover,
    &:focus {
      cursor: pointer;
      color: $white-trans2;
      outline: 0;
    }
  }
  &__dropdown-icon {
    margin-left: $sp-margin-smaller;
    transform: scale(0.875);
    transform-origin: bottom;
  }

  &__folded,
  &__initial {
    display: inline-flex;
  }
  &__folded {
    margin-right: $sp-margin-small;
  }
  &__initial {
    white-space: nowrap;
  }
  &__initial &__item {
    display: inline-flex;
    > a {
      color: $link-dark;
      &:hover,
      &:focus {
        color: rgba($link-dark, 0.75);
      }
      &:active {
        color: rgba($link-dark, 0.5);
      }
    }
  }
  &__folded &__item {
    display: block;
  }
  &__folded &__separator {
    display: none;
  }

  &__separator {
    margin-left: $sp-margin-smaller;
    margin-right: $sp-margin-smaller;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .is-hidden {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/topbar/Breadcrumb.vue